export const createTrackCarMini = /* GraphQL */ `
  mutation CreateTrackCar($input: CreateTrackCarInput!) {
    createTrackCar(input: $input) {
      id
      active
      trackId
      sortKey
      shipmentId
      parentType
      locationFullName
      reloadYardId
    }
  }
`;

export const updateTrackCarMini = /* GraphQL */ `
  mutation UpdateTrackCar($input: UpdateTrackCarInput!) {
    updateTrackCar(input: $input) {
      id
      active
      trackId
      sortKey
      locationFullName
      shipmentId
      parentType
      reloadYardId
    }
  }
`;

export const deleteTrackCarMini = /* GraphQL */ `
  mutation DeleteTrackCar($input: DeleteTrackCarInput!) {
    deleteTrackCar(input: $input) {
      id
      trackId
      shipmentId
      parentType
      reloadYardId
    }
  }
`;

export const onUpdateLocationMini = /* GraphQL */ `
  subscription OnUpdateLocation($owner: String) {
    onUpdateLocation(owner: $owner) {
      id
      reloadYardId
      capacityUsed
      capacityAllocated
      length
    }
  }
`;

export const onUpdateAisleMini = /* GraphQL */ `
  subscription OnUpdateAisle($owner: String) {
    onUpdateAisle(owner: $owner) {
      id
      reloadYardId
      capacityUsed
      length
    }
  }
`;

export const onCreateTrackCarMini = /* GraphQL */ `
  subscription OnCreateTrackCar {
    onCreateTrackCar {
      id
      active
      trackId
      sortKey
      locationFullName
      shipmentId
      parentType
      reloadYardId
    }
  }
`;

export const onUpdateTrackCarMini = /* GraphQL */ `
  subscription OnUpdateTrackCar {
    onUpdateTrackCar {
      id
      active
      trackId
      sortKey
      locationFullName
      shipmentId
      parentType
      reloadYardId
    }
  }
`;

export const onDeleteTrackCarMini = /* GraphQL */ `
  subscription OnDeleteTrackCar {
    onDeleteTrackCar {
      id
      trackId
      shipmentId
      parentType
      reloadYardId
    }
  }
`;
